module.exports = __webpack_public_path__ + "media/images/players/MERONK_ADRIAN-f6b7d098f11d4a9e56fa7c1d92cb56f3.png";